module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_pp23_5.5c4a5792.png";